import React from 'react';

import { FormattedMessage } from 'react-intl';

export const SignedInView = () => (
    <div>
        <h2 className="tw-text-l tw-font-semibold tw-mb-8">
            <FormattedMessage id="login.signedIn.title" defaultMessage="You are now signed in" />
        </h2>
        <p className="tw-text-neutral-subdued tw-text-s">
            <FormattedMessage
                id="login.signedIn.description"
                defaultMessage="If you are not being redirected, {link}."
                values={{
                    link: (
                        <a
                            href="/"
                            className="tw-text-primary tw-no-underline hover:tw-underline"
                        >
                            <FormattedMessage
                                id="login.signedIn.clickHere"
                                defaultMessage="click here"
                            />
                        </a>
                    ),
                }}
            />
        </p>
    </div>
);
